import React, { useState, useRef } from "react";
import "./video.css";

const Video = () => {
  const [iniciar, setIniciar] = useState(false);

  const entrarEmTelaCheia = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  const handleIniciar = () => {
    entrarEmTelaCheia();
    setIniciar(true);
  };

  if (!iniciar) {
    return (
      <div className="video-tela-inicial">
        <button onClick={handleIniciar} className="video-botao-iniciar">
          Click Aqui - Iniciar Apresentação TV Posto Saulo 3
        </button>
      </div>
    );
  }

  return (
    <div className="video-container">
      <video
        src="https://tvpostosaopaulo3.com.br/videos/videopostosaopaulo3.mp4"
        autoPlay
        muted
        loop
        className="video-player"
      />
    </div>
  );
};

export default Video;
